import { useState, useEffect, useRef } from "react";
import { getVideoFromIndexedDB, saveVideoToIndexedDB } from "./db";

export const VideoPlayer = ({ button }) => {
    const vids = button.content; // Array di video
    const [currIdx, setCurrIdx] = useState(0); // Stato per l'indice del video corrente
    const [localUrls, setLocalUrls] = useState({}); // { url: objectUrl }
    const videoRef = useRef(null);

    // Se cache presente → usa blob. Altrimenti stream da URL e scarica in background.
    useEffect(() => {
        const today = new Date().toISOString().slice(0, 10);
        vids.forEach(async (vid) => {
            const videoPath = vid.url;
            if (!videoPath) return;
            const cacheKey = `${videoPath}?date=${today}`;
            if (localUrls[videoPath]) return;

            const cached = await getVideoFromIndexedDB(cacheKey);
            if (cached) {
                const objectUrl = URL.createObjectURL(cached);
                setLocalUrls(prev => ({ ...prev, [videoPath]: objectUrl }));
                return;
            }
            // No cache: lascia che video element streammi direttamente. Scarica in bg per cache futura.
            fetch(`https://api.psicopatici.com/public/${videoPath}?date=${today}`)
                .then(r => r.blob())
                .then(b => saveVideoToIndexedDB(cacheKey, b))
                .catch(e => console.error("bg cache fail", videoPath, e));
        });
        // eslint-disable-next-line
    }, [vids]);

    // Force reload+play quando cambia il video corrente (rotazione multi-video)
    useEffect(() => {
        const v = videoRef.current;
        if (!v) return;
        v.load();
        v.play().catch(() => {});
    }, [currIdx, localUrls]);

    if (!vids[currIdx]) return null; // Se il video corrente non esiste, non renderizzare nulla

    const { url } = vids[currIdx]; // Ottieni l'URL del video corrente

    const onVideoEnd = () => {
        if (vids.length <= 1) {
            const v = videoRef.current;
            if (v) {
                v.currentTime = 0;
                v.play().catch(() => {});
            }
            return;
        }
        setCurrIdx((prev) => (prev + 1) % vids.length);
    };

    const handleVideoError = () => {
        const video = videoRef.current;
        if (video) {
            console.warn("Video error, attempting reload...");
            video.load();
            video.play().catch(() => {});
        }
    };

    const handleVideoStalled = () => {
        const video = videoRef.current;
        if (video && video.paused) {
            console.warn("Video stalled, attempting to resume...");
            video.play().catch(() => {});
        }
    };

    return (
        <div className="banner pointer-events">
            <video
                ref={videoRef}
                src={localUrls[url] || `https://api.psicopatici.com/public/${url}?date=${new Date().toISOString().slice(0, 10)}`}
                style={{
                    cursor: "pointer",
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                }}
                autoPlay
                muted
                playsInline
                loop={vids.length <= 1}
                onEnded={onVideoEnd}
                onError={handleVideoError}
                onStalled={handleVideoStalled}
                onWaiting={handleVideoStalled}
                controls={false}
            />
        </div>
    );
};